<template>
  <div class="arquivo">
    <div class="comments">
      <h3>{{ translate.commentBox }}</h3>
      <div v-if="commentsAll">
        <div
          v-for="(comment, index) in commentsAll"
          :key="index"
          class="comment-body mt-3"
        >
          <div class="cabecalho">
            <img
              v-if="comment.ativo == 'true'"
              :src="comment.gold == 'true' ? IconeBdsGold : IconeBds"
              :class="{ 'icone-gold': comment.gold == 'true' }"
              :alt="comment.gold == 'true' ? 'Assinante Gold' : 'Assinante'"
              :title="comment.gold == 'true' ? 'Assinante Gold' : 'Assinante'"
            />
            <strong class="name">{{
              comment.user.nickname ?? comment.user.name
            }}</strong>
            {{ translate.wroteOn }} {{ comment.date }}:
          </div>
          <!-- v-html seguro: renderCommentHtml escapa o texto e só reconstrói
               os links (tags <a> e URLs digitadas). -->
          <span
            :class="{ 'texto-gold': comment.gold == 'true' }"
            v-html="renderCommentHtml(comment.comment)"
          ></span>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import IconeBds from "@/assets/img/icone_BDS.png";
import IconeBdsGold from "@/assets/img/icone-bds-gold.png";
import api from "@/api";
import { renderCommentHtml } from "@/shared/utils/commentHtml";
import { useCookies } from "vue3-cookies";
const { cookies } = useCookies();

defineProps(["translate"]);
const commentsAll = ref<any>([]);

async function getComments() {
  api
    .get("v1/blog/getCommentsAllBlogs", {
      headers: {
        "X-Custom-Data": cookies.isKey("commentUser")
          ? cookies.get("commentUser")
          : "",
      },
    })
    .then(({ data }) => {
      commentsAll.value = data.comments;
    });
}
onMounted(() => {
  getComments();
});
</script>
<style scoped lang="css">
h3 {
  color: #000000;
  font-family: "Roboto-Medium";
  font-size: 18px !important;
  font-weight: 500;
  letter-spacing: 0;
  margin-top: 10px;
}

.arquivo {
  width: 100%;
}

.arquivo div.comments {
  border: 1px solid #dfdfdf;
  background-color: white;
  max-height: 1200px !important;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 18px;
  padding-left: 20px;
}

.arquivo div.comments img {
  width: 12px;
  margin-right: 2px;
  object-fit: cover;
}

/* Assinante Gold: ícone maior para dar ênfase ao comentário. */
.arquivo div.comments img.icone-gold {
  width: 12px;
  height: auto;
  vertical-align: -3px;
}

.name {
  color: black;
  font-family: "Roboto-Regular";
  font-size: 13px;
  letter-spacing: 0;
}

.comment-body .cabecalho {
  color: #5b5858;
  font-family: "Roboto-Regular";
  font-size: 13px;
  letter-spacing: 0;
}

.comment-body span {
  color: #5b5858;
  font-family: "Roboto-Regular";
  font-size: 13px;
  letter-spacing: 0;
  line-height: 15px !important;
  display: block;
}

/* Assinante Gold: texto do comentário em negrito. */
.comment-body span.texto-gold {
  font-family: "Roboto-Bold";
}

/* Links do comentário (gerados via v-html, daí o :deep). */
.comment-body span :deep(a) {
  color: #b20000;
  text-decoration: underline;
  word-break: break-word;
  overflow-wrap: anywhere;
}
</style>
